export const HOME = {
  WELCOME: "مرحبا،",
};

export const BUTTONS = {
  NEW_TRANSACTION: "بدء معاملة جديدة",
  START_TRANSACTION: "ابدء معاملتك الأولى الآن",
};
